import React from 'react';
import { ResetButton } from './ResetButton';
import type { FieldReset } from '../../domain/baselines';

type FieldLabelProps = {
  label: string;
  htmlFor?: string;
  id?: string;
  reset?: FieldReset;
};

export function FieldLabel({ label, htmlFor, id, reset }: FieldLabelProps) {
  const labelNode = htmlFor ? (
    <label className={"email-builder-settings-field-label"} htmlFor={htmlFor}>
      {label}
    </label>
  ) : (
    <span id={id} className={"email-builder-settings-field-label"}>
      {label}
    </span>
  );

  return (
    <div className={"email-builder-settings-field-label-row"}>
      {labelNode}
      <span className={"email-builder-settings-reset-slot"}>
        {reset ? <ResetButton onClick={reset.onReset} /> : null}
      </span>
    </div>
  );
}
